"use strict";
(self["webpackChunkbranch_basics"] = self["webpackChunkbranch_basics"] || []).push([[3078],{

/***/ 3078:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ BlogTemplate)
/* harmony export */ });
function BlogTemplate() {

  const settings = {
  }

  ;(function init() {
    console.log("BlogTemplate initing!!")
    // initEventListeners()
  })()


  function initEventListeners() {

  }
}


/***/ })

}]);